/**
 * Manages the automatic saving of the dashboard design to the browser's localStorage.
 * It tracks changes ('dirty' state), periodically saves the design to prevent data loss, and provides
 * functionality to retrieve or clear the saved state upon initialization.
 */
namespace appn.designerv2.autosave {
    let isDirty = false;
    let timerId: number | null = null;
    const AUTOSAVE_KEY = 'dashboard_autosave_' + window.location.pathname;
    const AUTOSAVE_INTERVAL_MS = 60 * 1000; // 1 minute

    export function init(canSave: boolean) {
        if (!canSave) 
            return;

        $(window).on('beforeunload', () => {
            if (isDirty)
                saveNow();
        });

        if (timerId) 
            clearInterval(timerId);
        timerId = window.setInterval(run, AUTOSAVE_INTERVAL_MS);
    }

    export function markDirty() {
        isDirty = true;
    }

    function run() {
        if (!isDirty) 
            return;
        
        saveNow();
    }

    function saveNow() {
        const design = designer.getDesignForSave();
        if (!design) 
            return;

        const storeObj = {
            design: design,
            timestamp: new Date().getTime()
        };

        try {
            localStorage.setItem(AUTOSAVE_KEY, JSON.stringify(storeObj));
            isDirty = false; // Reset the dirty flag after a successful save

            console.log("Design autosaved...");
        } catch (e) {
            console.error("Failed to auto-save the design.", e);
        }
    }

    export function getSavedDesign(): IDesign | null {
        try {
            const stored = localStorage.getItem(AUTOSAVE_KEY);
            if (!stored) 
                return null;

            const storeObj = JSON.parse(stored);
            const TEN_MINUTES = 10 * 60 * 1000;
            if (storeObj && storeObj.timestamp && (new Date().getTime() - storeObj.timestamp < TEN_MINUTES))
                return storeObj.design;
            else 
                clear();
            
        } catch (e) {
            console.error("Failed to retrieve auto-saved design.", e);
            clear(); // Clear potentially corrupted data
        }
        return null;
    }

    export function clear() {
        try {
            localStorage.removeItem(AUTOSAVE_KEY);
            isDirty = false;
        } catch (e) {
            console.error("Failed to clear auto-saved design.", e);
        }
    }
}
